export default __webpack_public_path__ + "static/media/blog.d92b888a.svg";